var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5103 16.4026L17.1253 14.0176C18.1017 12.1886 18.4126 10.0773 18.0046 8.04455C17.5967 6.0118 16.4953 4.18388 14.8888 2.8733C13.2823 1.56271 11.2705 0.850862 9.19723 0.859452C7.12397 0.868041 5.11808 1.59654 3.52249 2.92039C1.92691 4.24424 0.840729 6.08123 0.449654 8.11728C0.0585794 10.1533 0.386899 12.262 1.37848 14.0828C2.37006 15.9036 3.96332 17.3234 5.88586 18.0995C7.8084 18.8755 9.94083 18.9597 11.9186 18.3376L14.7412 21.1602C17.8872 24.347 22.6587 19.5078 19.5103 16.4026ZM2.46991 9.75032C2.46991 8.41529 2.86579 7.11025 3.60749 6.00022C4.34918 4.89019 5.40339 4.02502 6.63679 3.51413C7.87019 3.00324 9.22739 2.86957 10.5368 3.13002C11.8461 3.39047 13.0489 4.03334 13.9929 4.97735C14.9369 5.92135 15.5798 7.12409 15.8402 8.43346C16.1007 9.74283 15.967 11.1 15.4561 12.3334C14.9452 13.5668 14.08 14.621 12.97 15.3627C11.86 16.1044 10.5549 16.5003 9.2199 16.5003C7.4303 16.4984 5.71455 15.7866 4.44911 14.5211C3.18366 13.2557 2.47187 11.5399 2.46991 9.75032Z",
    fill: "#CEB2E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a685edf3da829f6f69a491658c69c750.svg";
export { ForwardRef as ReactComponent };